import { EntityModel, MatrixModel, RoleModel } from "../types";

import { ExpandedTable } from "../../../../ui-kit";
import { PermissionMatrixTable } from "./PermissionMatrixTable";
import { useColumns } from "../../../../hooks/useColumns";

const columns = [
  {
    title: "Наименование подраздела",
    dataIndex: "entityName",
    align: "left",
  },
];

type EntitiMatrixTableProps = {
  matrixChild: MatrixModel;
  roles: RoleModel[];
};
export const EntitiMatrixTable = ({
  matrixChild,
  roles,
}: EntitiMatrixTableProps) => {
  const { entities = [] } = matrixChild;

  const cols = useColumns<EntityModel>(columns);

  return (
    <div style={{ paddingLeft: "30px" }}>
      <ExpandedTable<EntityModel>
        rowKey={(row) => row.entityName}
        data={entities.map((entity) =>
          !entity.entityName
            ? { ...entity, entityName: "Общие права" }
            : entity,
        )}
        columns={cols}
        className="hello-blya"
        expandedRowRender={(r) => (
          <PermissionMatrixTable entity={r} roles={roles} />
        )}
      />
    </div>
  );
};
